import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { ColumnChartLoading } from '../../../../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart.loading';
import { Dot } from '../../../../../../CommonComponents/OPL/Dot/Dot';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { LoadingTable } from './components/Table/Table.loading';

export const LoadingLongevityAnalysis = () => {
  return (
    <Box position="relative">
      <Box display="flex" flexDirection="column" css={({ theme }) => ({ gap: theme.space['16'] })}>
        <Text variant="cardTitle" pt="32" pb="4">
          Probability of Annual Success
        </Text>

        <Card display="flex" hasBorder p="24">
          <Box display="flex" justifyContent="space-between" flex="1">
            <Box width="100%">
              <ColumnChartLoading categoriesCount={1} chartHeight={280} />
            </Box>
          </Box>

          <Box
            as="ul"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            p="0"
            css={({ theme }) => ({
              gap: theme.space['24'],
              minWidth: '300px',
            })}
          >
            <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
              <Box width="12px" height="12px" bg="neutral.400" />

              <Shimmer width={90} height={16} />
            </Box>

            <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
              <Box width="12px" height="12px" bg="neutral.400" />

              <Shimmer width={120} height={16} />
            </Box>

            <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
              <Box width="12px" height="12px" bg="neutral.400" />

              <Shimmer width={110} height={16} />
            </Box>

            <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
              <Dot bg="neutral.400" />

              <Shimmer width={70} height={16} />
            </Box>

            <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
              <Dot bg="neutral.400" />

              <Shimmer width={100} height={16} />
            </Box>

            <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
              <Box width="12px" height="12px" bg="neutral.400" />

              <Shimmer width={100} height={16} />
            </Box>

            <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
              <Box width="12px" height="12px" bg="neutral.400" />

              <Shimmer width={100} height={16} />
            </Box>
          </Box>
        </Card>

        <Card>
          <Box
            display="Flex"
            justifyContent="flex-end"
            css={({ theme }) => ({ gap: theme.space['16'] })}
            p="8"
            width="100%"
          >
            <Shimmer width={120} height={36} />

            <Shimmer width={100} height={36} />

            <Shimmer width={90} height={36} />
          </Box>

          <LoadingTable />
        </Card>
      </Box>
    </Box>
  );
};
